import React, { createContext, useContext, useEffect, useState } from 'react';
import { getAuthHeaders } from '../utils/authHeaders';
const AccountingCompany = createContext(null);
export function useAccountingCompany() {
  const holdingCompany = useContext(AccountingCompany);
  return holdingCompany || localStorage.getItem('selectedCompanyId');
}
export default function HoldingAccounting({ children }) {
  const [company, setCompany] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    const api = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
    fetch(`${api}/companies`, { headers: getAuthHeaders(), signal: controller.signal })
      .then(r => { if (!r.ok) throw new Error('Unable to load holding accounting.'); return r.json(); })
      .then(data => {
        const ledger = (data.companies || []).find(c => c.code === 'ACCESS-LB-TECHNOLOGY' || c.name === 'ACCESS LB Consultancy');
        if (!ledger) throw new Error('Holding accounting ledger is unavailable.');
        setCompany(String(ledger.id));
      }).catch(e => { if (!controller.signal.aborted) setError(e.message); });
    return () => controller.abort();
  }, []);
  if (!company) return <p role="status" style={{ padding: 32 }}>{error || 'Loading holding accounting…'}</p>;
  return <AccountingCompany.Provider value={company}>{children}</AccountingCompany.Provider>;
}
